module.exports = __webpack_public_path__ + "static/Q2Answer2_Costarica_wishmas-8c3ab4329ac15ac94cff5c447c936be3.jpg";